import { getTextField } from '@lender/utils';
import _ from 'lodash';

import { checkIsBracketsOpen } from 'utils/checkIsBracketsOpen';

import { getValuesInsideCurlyBrackets } from '../string';

export const getTextFieldBuilder = (options, { singleOption, isRequired = true }) =>
  getTextField({ isRequired })
    .test({
      message: 'value inside {...} should be one of options',
      test(value) {
        if (!value) {
          return true;
        }

        const optionsFromValue = getValuesInsideCurlyBrackets(value);
        const allOptionNames = options.map(({ name }) => name);

        return optionsFromValue
          ? _.difference(optionsFromValue, allOptionNames).length === 0
          : true;
      },
    })
    .test({
      message: 'curly brackets are special symbols and should have pair',
      test(value) {
        if (!value) {
          return true;
        }

        return !checkIsBracketsOpen(value);
      },
    })
    .test({
      message: 'only one pair of {} is allowed',
      test(message) {
        if (!singleOption) {
          return true;
        }

        const openBrackets = [...message.matchAll(/{/g)].length;
        const closedBrackets = [...message.matchAll(/}/g)].length;

        return !(openBrackets > 1 || closedBrackets > 1);
      },
    });
